export default __webpack_public_path__ + "static/media/5.774f8cab.png";